import React from 'react';
import PropTypes from 'prop-types';
import YesIcon from 'Icons/YesIcon';
import NoIcon from 'Icons/NoIcon';
import './tiers.scss';
var yes = React.createElement(YesIcon, { className: "text-success mr-1" });
var no = React.createElement(NoIcon, { className: "text-danger mr-1" });
var ReservationTier = function (props) {
    var bestTierLabel = props.bestTierLabel, plan = props.plan, plans = props.plans;
    var isNotCheapestPlan = plan.price > plans[0].price;
    return (React.createElement("article", { className: "tier ".concat(!!bestTierLabel && 'tier--best') },
        React.createElement("div", { className: "tier__best-offer" }, bestTierLabel),
        React.createElement("h4", { className: "tier__title" },
            "Abonament \"",
            plan.label,
            "\""),
        React.createElement("div", { className: "tier__price" },
            React.createElement("span", { className: "tier__order-amount" },
                plan.amount,
                " rezerwacji w miesi\u0105cu"),
            React.createElement("span", { className: "tier__price-number" },
                plan.price,
                " z\u0142"),
            React.createElement("span", { className: "tier__price-text" }, "per restauracja")),
        React.createElement("ul", { className: "tier__offer-list" },
            React.createElement("li", { className: "tier__offer-item" },
                yes,
                " automatyczne rezerwacje z Messenger"),
            React.createElement("li", { className: "tier__offer-item" },
                yes,
                " automatyczne rezerwacje z Facebook"),
            React.createElement("li", { className: "tier__offer-item" },
                yes,
                " automatyczne rezerwacje z Map Google"),
            React.createElement("hr", null),
            React.createElement("li", { className: "tier__offer-item" },
                yes,
                " przypomnienie wiadomo\u015Bci\u0105 SMS w dniu rezerwacji"),
            React.createElement("li", { className: "tier__offer-item" },
                yes,
                " historia rezerwacji ",
                plan.history),
            React.createElement("li", { className: "tier__offer-item" },
                isNotCheapestPlan ? yes : no,
                " integracja systemu do rezerwacji ze stron\u0105 www"),
            React.createElement("li", { className: "tier__offer-item" },
                isNotCheapestPlan ? yes : no,
                " mo\u017Cliwo\u015B\u0107 wysy\u0142ki SMS do rezerwuj\u0105cych")),
        props.children));
};
var reservationTierShape = PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    featuredText: PropTypes.string,
    label: PropTypes.string.isRequired,
    history: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
});
ReservationTier.propTypes = {
    bestTierLabel: PropTypes.string,
    children: PropTypes.element,
    plan: reservationTierShape.isRequired,
    plans: PropTypes.arrayOf(reservationTierShape.isRequired).isRequired,
};
export default ReservationTier;
